
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import SearchDate from '~/components/Common/UI/Search/SearchDate'
import api from '~/api/'
import { classUpDownConverter } from '~/utils'

export default {
    components: {
        SearchDate,
    },
    data() {
        return {
            newsType: 'MENU_STOCK_OPINION',
            dataListUp: [],
            dataListDown: [],
            dataListNew: [],
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),
    },
    watch: {
        getSearch() {
            this.getList()
        },
    },
    created() {
        this.getList()
    },

    methods: {
        async getList() {
            this.dataListUp=[]
            this.dataListDown=[]
            this.dataListNew=[]
            const params = {
                menuType: this.newsType,
                ...this.getSearch,
            }
            const res = (await api.getStockFirmOpinionAndStrongBuying(params)).data
            res.itmes = res.items.sort((f, r) => {
                return f.stockName < r.stockName
                    ? -1
                    : f.stockName > r.stockName
                    ? 1
                    : 0
            })
            /* 
                220415 meej 상향, 하향, 신규 테이블 따로 생성 
            */
            for(let i=0;i<res.items.length;i++){
                if (res.items[i].OPINION_UPDOWN0 === "-1"){ // 하향
                    // 23.03.08 SUYE 투자의견 하향일때, 목표주가는 상향된 경우 상향에도 추가
                    if(res.items[i].OLD_PRICE && res.items[i].PRICE){
                        if(res.items[i].OLD_PRICE < res.items[i].PRICE){
                            // this.dataListUp.push(res.items[i])
                        }
                    }
                    this.dataListDown.push(res.items[i])
                } else if (res.items[i].OPINION_UPDOWN0 === "1"){ // 상향
                    this.dataListUp.push(res.items[i])
                } else { // 신규
                    this.dataListNew.push(res.items[i])
                }
            }
        },
        onClickItem(id) {
            console.log('onClickItem')
        },
        onClickStock(code) {
            const routeData = this.$router.resolve({
                name: `/stockitem?code=${code}`,
            })
            window.open(
                routeData.location.name,
                'StockItem',
                'width=1200px,height=1000,scrollbars=1,resizable=yes'
            )
        },
        upDownCssApply(value) {
            return classUpDownConverter(value)
        },
    },
}
